export const siteStats = {
  clues: 12480,
  discussions: 386900,
  users: 24100,
  todayNew: 168,
};

export const trendingKeywords = [
  "地铁新线路通车",
  "夜市摊主的故事",
  "国产手机新旗舰",
  "写字楼里的隐形加班",
  "老城区改造",
  "县城咖啡店",
  "演唱会抢票",
  "外卖员的雨天",
  "二手市集淘货",
  "露营装备避坑",
];

export const categories = [
  {
    key: "city",
    name: "城市见闻",
    icon: "ri-building-2-line",
    count: 2360,
    desc: "家门口的新变化、城市里的新鲜事，都值得被记录。",
  },
  {
    key: "life",
    name: "生活消费",
    icon: "ri-shopping-bag-3-line",
    count: 1980,
    desc: "吃穿住用行的真实体验，帮别人少踩一个坑。",
  },
  {
    key: "tech",
    name: "科技数码",
    icon: "ri-smartphone-line",
    count: 1740,
    desc: "新机上手、软件体验、智能好物，理性聊不吹不黑。",
  },
  {
    key: "work",
    name: "职场观察",
    icon: "ri-briefcase-4-line",
    count: 1520,
    desc: "职场里说不出口的观察，来这里交换真实经验。",
  },
  {
    key: "culture",
    name: "文娱现场",
    icon: "ri-movie-2-line",
    count: 1290,
    desc: "影剧综现场、演出见闻，和同好一起讨论。",
  },
  {
    key: "travel",
    name: "出行玩乐",
    icon: "ri-roadster-line",
    count: 1160,
    desc: "周末去哪、路线怎么走，把好去处分享给更多人。",
  },
];

export const posts = [
  {
    id: "metro-line-7-open",
    title: "地铁7号线今天正式通车，沿线这几个站口原来藏着这么多小店",
    excerpt: "早上专门坐了首班车，新线路比预想中快很多。出站口旁边那条老街不知道还能保留多久，先替大家把好吃的探了一圈。",
    category: "城市见闻",
    categoryKey: "city",
    author: "背着相机坐地铁",
    time: "2小时前",
    comments: 126,
    likes: 842,
    cover: "https://readdy.ai/api/search-image?query=warm%20editorial%20photo%20of%20a%20quiet%20city%20street%20with%20small%20shops%20and%20soft%20afternoon%20light%2C%20coral%20and%20amber%20tones%2C%20film%20grain%2C%20documentary%20style%2C%20no%20text&width=800&height=600&seq=kanliao-post-01&orientation=landscape",
    tags: ["城市更新", "地铁", "探店"],
  },
  {
    id: "night-market-story",
    title: "在夜市摆摊三年，我想说说那些没人注意的收摊时刻",
    excerpt: "凌晨一点半，最后一批客人走后才是摊主们真正聊天的时间。那些互相借零钱、帮忙看摊的瞬间，比白天热闹多了。",
    category: "生活消费",
    categoryKey: "life",
    author: "老陈的烤串车",
    time: "5小时前",
    comments: 203,
    likes: 1360,
    cover: "https://readdy.ai/api/search-image?query=cozy%20warm%20night%20market%20scene%20with%20glowing%20lanterns%20and%20food%20stalls%2C%20amber%20and%20deep%20orange%20lighting%2C%20soft%20bokeh%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=kanliao-post-02&orientation=landscape",
    tags: ["夜市", "人间烟火", "真实故事"],
  },
  {
    id: "new-phone-hands-on",
    title: "国产新旗舰上手一周：影像确实进步，但这三点官方没怎么说",
    excerpt: "拿到手用了七天，白天样张几乎不用修，但夜景高光压得有点狠。续航和发热的真实表现，和参数表上写的不太一样。",
    category: "科技数码",
    categoryKey: "tech",
    author: "参数之外",
    time: "8小时前",
    comments: 178,
    likes: 964,
    cover: "https://readdy.ai/api/search-image?query=minimal%20studio%20flat%20lay%20of%20a%20modern%20smartphone%20on%20warm%20beige%20surface%2C%20soft%20shadow%2C%20coral%20accent%20props%2C%20clean%20product%20photography%2C%20no%20text&width=800&height=600&seq=kanliao-post-03&orientation=landscape",
    tags: ["数码", "测评", "理性讨论"],
  },
  {
    id: "office-invisible-overtime",
    title: "写字楼里的「隐形加班」，到底是谁在默默承担",
    excerpt: "下班后群里那条「顺手改一下」，没有加班费也没有调休。问了身边十几个朋友，发现大家遇到的版本竟然高度相似。",
    category: "职场观察",
    categoryKey: "work",
    author: "工位上的观察者",
    time: "1天前",
    comments: 341,
    likes: 2110,
    cover: "https://readdy.ai/api/search-image?query=empty%20warm%20modern%20office%20desk%20at%20dusk%20with%20laptop%20glow%2C%20amber%20and%20muted%20terracotta%20tones%2C%20calm%20editorial%20mood%2C%20no%20text&width=800&height=600&seq=kanliao-post-04&orientation=landscape",
    tags: ["职场", "讨论", "共鸣"],
  },
  {
    id: "old-town-renewal",
    title: "住了二十年的老城区要改造了，我把巷子拍了下来",
    excerpt: "听说下个月就要动工，这两天赶紧回去走了一遍。墙上的涂鸦、理发店的旧转灯、还有总在树下下棋的几位大爷。",
    category: "城市见闻",
    categoryKey: "city",
    author: "巷口的风",
    time: "1天前",
    comments: 97,
    likes: 720,
    cover: "https://readdy.ai/api/search-image?query=narrow%20old%20town%20alley%20with%20warm%20sunlit%20walls%20and%20hanging%20plants%2C%20terracotta%20and%20cream%20tones%2C%20nostalgic%20film%20look%2C%20no%20text&width=800&height=600&seq=kanliao-post-05&orientation=landscape",
    tags: ["老城", "记录", "回忆"],
  },
  {
    id: "county-coffee-shop",
    title: "在县城开咖啡店的第二年，我总结了几条反常识的经验",
    excerpt: "很多人以为县城开店靠便宜，其实回头客更在意的是「坐得住」。桌椅高度、插座位置这些小细节，比菜单更影响生意。",
    category: "生活消费",
    categoryKey: "life",
    author: "小城慢半拍",
    time: "2天前",
    comments: 154,
    likes: 1035,
    cover: "https://readdy.ai/api/search-image?query=small%20cozy%20coffee%20shop%20interior%20with%20wooden%20furniture%20and%20warm%20window%20light%2C%20coral%20and%20cream%20palette%2C%20editorial%20lifestyle%20photography%2C%20no%20text&width=800&height=600&seq=kanliao-post-06&orientation=landscape",
    tags: ["创业", "小店", "经验分享"],
  },
  {
    id: "concert-ticket-tips",
    title: "抢演唱会门票连续失败了四次，这次终于摸清了节奏",
    excerpt: "不是运气问题，是流程问题。提前把信息填好、避开整点、换一个网络环境，这几点做到之后成功率明显不一样。",
    category: "文娱现场",
    categoryKey: "culture",
    author: "前排追光",
    time: "2天前",
    comments: 288,
    likes: 1490,
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20lights%20seen%20from%20the%20crowd%20with%20warm%20amber%20glow%20and%20soft%20haze%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=kanliao-post-07&orientation=landscape",
    tags: ["演出", "攻略", "讨论"],
  },
  {
    id: "rainy-day-rider",
    title: "雨天送外卖的第七个小时，我遇到了一件小事",
    excerpt: "顾客在备注里写「不着急，注意安全」，还在门口放了一杯热水。跑单三年，这样的备注我记了很久。",
    category: "生活消费",
    categoryKey: "life",
    author: "风雨里的骑士",
    time: "3天前",
    comments: 412,
    likes: 2680,
    cover: "https://readdy.ai/api/search-image?query=rainy%20city%20street%20at%20night%20with%20reflected%20warm%20light%20and%20umbrella%20silhouette%2C%20cozy%20amber%20palette%2C%20soft%20cinematic%20mood%2C%20no%20text&width=800&height=600&seq=kanliao-post-08&orientation=landscape",
    tags: ["温暖瞬间", "真实故事", "讨论"],
  },
  {
    id: "camping-gear-guide",
    title: "露营装备买了三大箱，真正用得上的其实不到一半",
    excerpt: "从入门到现在踩了不少坑。这份清单把「必须买」和「可以租」分得很清楚，希望能帮刚入坑的朋友省点钱。",
    category: "出行玩乐",
    categoryKey: "travel",
    author: "周末往山里跑",
    time: "3天前",
    comments: 133,
    likes: 908,
    cover: "https://readdy.ai/api/search-image?query=cozy%20camping%20scene%20with%20tent%20and%20warm%20string%20lights%20in%20green%20field%20at%20dusk%2C%20amber%20accents%2C%20editorial%20outdoor%20photography%2C%20no%20text&width=800&height=600&seq=kanliao-post-09&orientation=landscape",
    tags: ["露营", "避坑", "清单"],
  },
];

export const weeklyHot = [
  { rank: 1, title: "雨天送外卖的第七个小时，我遇到了一件小事", comments: 412, id: "rainy-day-rider" },
  { rank: 2, title: "写字楼里的「隐形加班」，到底是谁在默默承担", comments: 341, id: "office-invisible-overtime" },
  { rank: 3, title: "抢演唱会门票连续失败了四次，这次终于摸清了节奏", comments: 288, id: "concert-ticket-tips" },
  { rank: 4, title: "在夜市摆摊三年，我想说说那些没人注意的收摊时刻", comments: 203, id: "night-market-story" },
  { rank: 5, title: "国产新旗舰上手一周：影像确实进步，但这三点官方没怎么说", comments: 178, id: "new-phone-hands-on" },
];

export const activeUsers = [
  { name: "巷口的风", note: "本周发布 6 条线索", avatar: "巷" },
  { name: "参数之外", note: "本周评论 89 条", avatar: "参" },
  { name: "老陈的烤串车", note: "被推荐 320 次", avatar: "陈" },
  { name: "工位上的观察者", note: "讨论热度最高", avatar: "工" },
];

export const testimonials = [
  {
    name: "阿岚",
    role: "城市见闻板块常驻用户",
    quote: "以前刷到热点只能自己看看，现在能在这里看到别人补充的细节，很多事一下就清楚了。",
  },
  {
    name: "周周",
    role: "生活消费板块投稿人",
    quote: "我发过一条关于小店的经验，评论里有人补充了更实用的做法，比我自己想的还周到。",
  },
  {
    name: "老魏",
    role: "职场观察板块活跃评论者",
    quote: "这里的讨论氛围挺好，大家愿意讲道理，也愿意听不同的声音，这一点很难得。",
  },
];

export const submitSteps = [
  {
    step: "01",
    title: "写下你看到的",
    desc: "把时间、地点、事情经过说清楚，配上随手拍的照片会更有说服力。",
    icon: "ri-edit-2-line",
  },
  {
    step: "02",
    title: "选择主题分类",
    desc: "从城市见闻、生活消费、科技数码等分类里挑一个最贴近的，方便同好找到你。",
    icon: "ri-price-tag-3-line",
  },
  {
    step: "03",
    title: "等待讨论发酵",
    desc: "内容发布后，评论区会不断出现新的补充和看法，你的线索也许就此被更多人看见。",
    icon: "ri-chat-smile-3-line",
  },
];

export const faqs = [
  {
    q: "在99看料投稿需要注册账号吗？",
    a: "目前投稿与评论都支持直接参与，填写一个昵称即可。我们更看重内容本身的价值，希望降低参与门槛，让更多人愿意分享自己的见闻。",
  },
  {
    q: "投稿的线索会经过审核吗？",
    a: "会。我们会检查内容是否包含明显不实信息、人身攻击或侵犯他人隐私的部分。审核通常在一小时内完成，通过后即可在对应分类中看到。",
  },
  {
    q: "评论区可以讨论不同观点吗？",
    a: "当然可以。我们鼓励理性讨论，欢迎补充事实、提出不同角度。但请避免人身攻击、地域歧视以及未经证实的指控。",
  },
  {
    q: "我发的线索被删除了，怎么知道原因？",
    a: "如果内容被移除，系统会附带一条说明，告知涉及的具体规则。你也可以通过留言反馈入口联系我们，我们会在工作时间内回复。",
  },
  {
    q: "怎么反馈网站的使用问题？",
    a: "每条内容下方都有反馈入口，也可以在本站留言反馈区提交。描述得越具体，我们定位问题就越快。",
  },
  {
    q: "99看料和其他平台有什么不同？",
    a: "我们更关注每一条线索下面的讨论质量。相比追求数量，我们更希望内容的补充和观点能真正帮助到看到它的人。",
  },
];

export const brandValues = [
  {
    icon: "ri-eye-line",
    title: "忠于见闻",
    desc: "我们优先呈现亲历者的第一手描述，而不是层层转述后的二手结论。",
  },
  {
    icon: "ri-chat-1-line",
    title: "讨论优先",
    desc: "内容的价值不止于发布的那一刻，评论区里的补充同样重要。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重他人",
    desc: "保护当事人隐私，拒绝传播未经证实的指控与人身攻击。",
  },
  {
    icon: "ri-sparkling-2-line",
    title: "保持克制",
    desc: "不夸张、不煽动，把事实说清楚，剩下的交给读者判断。",
  },
];